<template>
  <div class="server-con">
   <div class="content">
    <div style="text-align:center">
        <span style="font-size:11px;font-family:FZLTHK--GBK1-0">更新日期：2021年【 11 】月【 19 】日</span>
    </div>
    <div class="title_text"> 博雅服务协议</div>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">&nbsp;&nbsp; </span><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">本《博雅游戏服务协议》（以下简称“本协议”）由您与博雅共同缔结，本协议具有法律效力。请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制博雅责任的条款、对您的权利进行限制的条款、约定争议解决方式和司法管辖的条款。博雅将以黑体加粗或其他合理方式提示您注意。</span></strong>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">&nbsp;&nbsp; </span></strong><strong><span style="font-size:11px;font-family: FZLTHK--GBK1-0">请您仔细阅读本协议，并选择接受或者不接受本协议。除非您同意并接受本协议中的所有条款，否则您无权使用、接收、下载、安装、启动、升级、登录、显示、运行、截屏博雅游戏服务，亦无权使用该游戏软件的某项功能或某一部分或者以其他的方式使用该游戏软件。在您点击接受、接收、下载、安装、启动、升级、登录、显示、运行、截屏博雅游戏，或者使用该游戏软件的某项功能、某一部分，或者以其他的方式使用该游戏软件的行为，均视为您已阅读并同意签署本协议，愿意接受本协议所有条款的约束。</span></strong>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">如果您未满18周岁，请在法定监护人的陪同下阅读本协议，并特别注意未成年人使用条款。</span></strong>
</p>
<p class="MsoListParagraph">
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">一、<span style="font:9px &#39;Times New Roman&#39;">&nbsp; </span></span></strong><strong><span style="font-size:11px;font-family: FZLTHK--GBK1-0">定义及说明：</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">如无特别说明，下列术语在本协议中的含义为：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">1.1; </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">本协议：指本协议正文、《博雅隐私政策》、游戏规则及其修订版本。主体是由您与深圳市东方博雅科技有限公司及关联公司共同签署。上述内容一经正式发布，即为本协议不可分割的组成部分。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">1.2 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">游戏规则：指博雅不时发布并修订的关于应用或网络游戏的用户守则、玩家条例、游戏公告、提示及通知等内容。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">1.3 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您：又称“玩家”或“用户”，指接受博雅游戏及其服务的自然人。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">1.4 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">软件要素作品，指从游戏软件当中分离出来的可以单独使用的单个作品的统称，是该游戏软件不可分割的组成部分，包括但不限于其中的：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（1）电子文档、文字、资料库、图片、图表、图饰、图示、照片、程序、音乐、舞蹈、色彩、版面框架、界面设计；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（2）可以单独构成著作权法意义上的作品的电脑程序、美术图片、文字内容、音乐、歌曲以及舞蹈等内容（又被分别称之为软件要素程序作品、软件要素美术作品、软件要素文字作品、软件要素音乐作品、软件要素歌曲作品和软件要素舞蹈作品）。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">1.5 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">游戏数据，指您或其他用户在使用和享受博雅游戏产品及服务的过程中产生的被服务器软件所即时记录、存储的各种数字、字母、符号和模拟量等的统称，它以电脑语言的形式反映您或其他用户在使用和享受博雅游戏产品及服务的过程及结果，包括但不限于记录用户使用和享受博雅游戏产品及服务过程的游戏日志以及游戏安全系统检测并记录下来的安全日志。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">1.6 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">游戏衍生品，指以某一游戏软件为原型，通过直接使用、修改、改编或者其他方式，利用该游戏软件或该游戏软件的软件要素作品、LOGO、名称和/或商标制作出来的物品的统称。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">1.7 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">知识产权，指下列任一和全部的知识产权以及其中所有内在的、衍生的和/或相关的权利：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（1）规程、设计、发明、发现以及由此已经申请到的和正在申请的专利；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（2）软件、软件要素作品、作品类衍生品、游戏过程衍生品、游戏编辑衍生品及其他作品的著作权、版权以及由其派生的各项权利；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（3）软件、软件要素作品、作品类衍生品、游戏过程衍生品、游戏编辑衍生品及其他作品的名称权、商标权以及其他形式的公司或产品标识所产生的权利。</span>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">二、游戏账号</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">如您需要使用和享受博雅游戏服务，则需要<strong>按照国家法律法规的相关要求，登录实名注册系统并进行实名注册。</strong></span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">2.1 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您承诺以其真实身份注册成为博雅的用户，并保证所提供的个人身份资料信息真实、完整、有效，依据法律规定和必备条款约定对所提供的信息承担相应的法律责任。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">2.2 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您以其真实身份注册成为博雅用户后，需要修改所提供的个人身份资料信息的，博雅及时、有效地为其提供该项服务。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">2.3</span><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您进行实名认证时，应提供有关您本人真实、合法、准确、有效的身份信息及其他相关信息，且不得以他人身份资料进行实名注册。</span></strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">否则，博雅有权终止为您提供服务，并有权对您的游戏账号采取包括但不限于警告、限制或禁止使用游戏账号全部或部分功能、删除游戏账号及游戏数据、删除相关信息、封禁游戏账号（以下简称“封号”）直至注销账号的处理措施，因此造成的一切后果由您自行承担。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">2.4 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您对登录后所持账号产生的行为依法享有权利和承担责任。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">2.5 </span><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">若您发现有他人冒用或盗用您的游戏账号及密码、或任何其他未经您合法授权使用的情形时，应立即以博雅要求的有效方式通知博雅并告知博雅需采取的措施。您通知博雅时，应提供与您注册身份信息相一致的个人有效身份信息，博雅收到您的有效请求并核实身份后，会根据您的要求或结合具体情况采取相应措施（包括但不限于暂停该账号的登录和使用等），博雅因根据您的请求采取相应措施而造成您及其他用户损失的，由您自行承担。若您没有提供有效身份信息或您提供的个人有效身份信息与所注册的身份信息不一致的，博雅有权拒绝您的请求，因此造成您损失的，由您自行承担。</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">2.7</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您有义务妥善保管其账号及密码，并正确、安全地使用其账号及密码。任何一方未尽上述义务导致账号密码遗失、账号被盗等情形而给您和他人的民事权利造成损害的，应当承担由此产生的法律责任</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">2.8 </span><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解并同意：为判断或核实您提供的相关实名注册信息是否真实或有效，博雅有权将您提供的实名注册信息提供给第三方进行整理、保存及比对等处理。且博雅会按照国家相关要求将您的实名注册信息运用于防沉迷系统之中，即博雅可能会根据您的实名注册信息判断您是否年满18周岁、您提交的实名身份信息是否规范或实名验证是否通过等，从而决定是否对您的游戏账号予以防沉迷限制。</span></strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">&nbsp;&nbsp;&nbsp;</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">2.9 </span><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解并同意，为高效利用服务器资源，如果您长期未使用游戏账号登录网络游戏，博雅有权在提前通知的情况下，对该账号及其账号下的游戏数据及相关信息采取删除等处置措施。</span></strong>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">3.</span></strong><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">服务的中止与终止</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">3.1</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您若发布违法信息、严重违背社会公德、以及其他违反法律禁止性规定的行为，博雅将立即终止对您提供服务。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">3.2 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您在接受博雅服务时实施任何不正当行为，博雅有权终止对您提供服务。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">3.3 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您提供虚假注册身份信息，或实施违反本协议的行为，博雅有权中止对您提供全部或部分服务；您知悉并同意，如博雅依据本协议对您的游戏账号采取封号处理措施的，具体封号期间由博雅根据您违规行为情节而定。博雅采取中止措施应当通知您并告知中止期间，中止期间应该是合理的，中止期间届满博雅应当及时恢复对您的服务。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">3.4 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅根据本条约定中止或终止对您提供部分或全部服务的，博雅应负举证责任。</span>
</p>
<p style="font-weight:900;font-size:11px;font-family:FZLTHK--GBK1-0">
    4.用户信息保护
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">4.1 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅要求您提供与其个人身份有关的信息资料时，应当事先以明确而易见的方式向您公开其隐私权保护政策和个人信息利用政策，并采取必要措施保护您的个人信息资料的安全。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">4.2 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">除《博雅隐私政策》规定的情形之外，未经您许可博雅不会向任何第三方提供、公开或共享您的个人身份信息。如果我们将您的信息用于本《博雅隐私政策》中未载明的其他用途，会事先征求您同意。但是，根据相关法律法规及国家标准，以下情形中，我们可能会共享、转让、公开披露个人信息而无需事先征得您的授权同意：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">4.2.1 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您或您监护人授权博雅披露的；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">4.2.2 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">有关法律要求博雅披露的；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">4.2.3 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">司法机关或行政机关基于法定程序要求博雅提供的；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">4.2.4 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅为了维护合法权益而向您提起诉讼或者仲裁时；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">4.2.5 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">应您监护人的合法要求而提供您个人身份信息时。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">4.3 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您同意并授权博雅为履行本协议之目的收集您的用户信息，这些信息包括您在实名注册系统中注册的信息、您游戏账号下的游戏数据以及其他您在使用网络游戏服务的过程中向博雅提供或博雅基于安全、用户体验优化等考虑而需收集的信息，博雅对您的用户信息的收集将遵循本协议及相关法律的规定。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">4.4 </span><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">保护用户信息及隐私是博雅的一项基本政策。除本协议另有规定外，博雅网络游戏服务对用户信息收集、使用及保护等将遵循《博雅隐私政策》等协议规定。除法律另有规定外，如您已同意或授权博雅依据前述协议或规定收集、使用或处理涉及您的个人信息的，在您撤回该同意或授权后，不影响博雅在此之前已基于您的同意或授权所进行的个人信息的收集、使用或处理，博雅对此前相关个人信息收集、使用或处理继续有效。</span></strong>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">5.</span></strong><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">合同目的</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">5.1 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">本协议旨在为博雅许可您使用和享受博雅游戏产品及服务提供合同依据，对您基于本协议在使用和享受博雅游戏产品及服务的过程中所享有的权利、所负有的义务进行约定。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">5.2</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅游戏的部分功能，并不是通过或者单独通过博雅游戏实现的，而是需要同时使用博雅和/或其合作单位开发的或运营的其他软件所实现的互联网服务才能实现。因此，您使用上述这部分功能的行为，不仅仅要受本协议的约束，亦同时受相应的其他软件许可使用协议或服务协议（以下统称“关联协议”）的约束。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">5.3</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您在使用和享受博雅游戏产品及服务的过程中，可能会使用到第三方授权博雅使用的软件或知识产权，该等使用必须是第三方授权范围内的、服从本协议目的的使用。您如果需要将其用于本协议合同目的之外的用途，请您直接与该等第三方联系，并取得其合法授权。</span>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">6.</span></strong><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">知识产权</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">6.1 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">本协议以及下列任何一项作品或资料的所有权及包括著作权在内的全部知识产权均由博雅享有，受《中华人民共和国著作权法》、《计算机软件保护条例》、《信息网络传播权保护条例》、《中华人民共和国商标法》等法律法规和相关的国际条约保护：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（1）博雅游戏之游戏软件；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（2）博雅游戏之软件要素作品；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（3）博雅游戏之游戏数据；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（4）博雅游戏之游戏过程衍生品、游戏编辑衍生品；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（5）您应博雅邀请，为博雅提供有关博雅游戏的测试、BUG及外挂跟踪汇报、软文撰写及推广、竞争情报收集等服务的过程中，向博雅提交的相应的作品或资料，如游戏测试报告、软文等。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">6.2 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">应博雅邀请，您提供给博雅用于博雅游戏的个人作品之著作权归您单独享有，博雅享有无期限的、全球范围内的、不可撤销、完全免费的使用权。该等作品一经您提供给博雅，即视为您授予了博雅该等使用权，而且博雅还可以将该等使用权转让或者转授权给其关联公司或者合作单位。双方另有约定的，从其约定。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">6.3 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅基于本协议，许可您对博雅游戏享有非专有使用权，即您对正在使用的博雅游戏当前版本所享有的非专有使用权。而且，该等非专有使用权是临时的、可撤销的、本协议约定范围内的使用权。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">6.4 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">本协议没有也不会将博雅游戏的发行权、信息网络传播权和/或出租权等某一项或某几项著作权权利、及其他的本协议未明示的权利许可给您，这些权利（或权能）都为博雅单独享有。博雅通过本协议许可您的，只是通过互联网线上使用和享受博雅游戏产品及服务的权利。</span>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">7.</span></strong><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">特别提示</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">7.1</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您对您的帐号、密码、实名注册以及防沉迷登记的个人信息负有保管责任，并就其帐号及密码项下之一切活动负全部责任。您须重视帐号密码和公开邮箱的密码保护。您保证在您的游戏帐号、密码未经授权而被使用、或者发生其他任何安全问题时，立即通知博雅。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">7.2</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：为了提高博雅游戏的安全性能，防止您的密码、实名注册以及防沉迷登记的个人信息被他人窃取而导致您无法凭借对应的帐号登录该游戏，博雅可能会随时将电脑病毒查杀技术、操作系统修复技术、电脑加密技术等有助于提高博雅游戏软件安全性能的电脑硬件或软件运用到博雅游戏当中。即便是如此，并不能免除或者减轻您对帐号及密码等有关资料所负有妥善保管义务。对此，您是完全同意的。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">7.3</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅一向遵守国家有关保护青少年身心健康的法律、政策，按照国家颁布的《网络游戏防沉迷系统开发标准》及相关法律法规和本协议的规定，采取切实有效的措施保护未成年人在使用博雅游戏服务过程中的合法权益，包括可能采取技术措施、禁止未成年人接触不适宜的游戏或者游戏功能、限制未成年人的游戏时间、付费、预防未成年人沉迷网络。在博雅游戏当中开发、内置了防沉迷系统。<strong>您充分理解到：博雅可能会将您的实名注册信息运用于防沉迷系统之中，即博雅可能会根据您的实名注册信息判断您是否年满18周岁，从而决定是否对您相应的游戏帐号予以防沉迷限制。</strong>对此，您是完全同意的。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">所有未成年人用户都应在法定监护人的指导下仔细阅读并遵照执行；其他玩家在使用博雅游戏服务的过程中应避免发布、产生任何有损未成年人身心健康的内容，共同营造健康游戏环境。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">7.4 </span><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：博雅游戏中使用到的游戏币、道具等均不具有任何财产性价值及功能，只限用户本人在游戏中使用。博雅严禁用户之间在游戏线上或线下进行任何无偿或有偿的游戏币赠予或转让等行为，博雅及其关联公司亦不会为用户所持有的游戏币、道具等虚拟物品提供任何形式的回兑、回购、变相兑换为现金或实物等变现服务或功能</span></strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">7.5 </span><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：博雅游戏中出现的广告链接，因该外部链接不由博雅实际控制，广告的真实性、准确性和合法性由广告信息发布者负责，博雅不提供任何保证，并不承担任何法律责任。</span></strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">7.6 </span><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅特别提醒：用户点击广告内容跳转至外部链接后，如出现购物、购买服务等消费内容，用户应谨慎操作，谨防被骗。博雅提示您，如您通过广告链接进行消费应自行留存广告链接、内容、消费记录、支付记录等相关凭证。用户通过广告链接进行的消费行为系自主、自愿行为，与博雅无关，博雅不承担任何责任。
</span></strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">。</span>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.</span></strong><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">用户行为守则及博雅权利</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.1 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅游戏与其他的线上使用的互联网软件一样，您如果要进行下载、安装、启动、登录、显示和/或运行，您至少必须自备一台电脑，在该电脑上安装博雅游戏的客户端软件，并保证其能够通过互联网与博雅游戏的服务器软件进行即时的信息（即电子数据）交互。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.2 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您在使用博雅游戏的收费功能时，应当按照博雅的要求支付相应的费用。而且，该等权利属于博雅的经营自主权，博雅保留随时改变经营模式的权利，即保留变更收费的费率标准、收费的软件功能、收费对象及收费时间等权利。同时，博雅也保留对博雅游戏进行升级、改版，增加、删除、修改、变更其功能或者变更其游戏规则的权利。您如果不接受该等变更的，应当立即停止使用博雅游戏；您继续使用博雅游戏的行为，视为您接受改变后的经营模式。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.3 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">基于本协议，您可以：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（1）接收、下载、安装、启动、升级、登录、显示、运行和/或截屏博雅游戏； </span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（2）创建博雅游戏角色，设置网名，查阅游戏规则、用户个人资料、游戏对局结果，开设游戏房间、设置游戏参数，使用聊天功能，在游戏中购买、赠送游戏币、游戏筹码、游戏道具；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（3）使用博雅游戏上列功能之外的其他的某一项或某几项功能。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.4 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您除了可以按照本协议的约定使用博雅游戏之外，不得进行任何侵犯博雅游戏或其软件要素作品的知识产权的行为，或者侵害线上游戏运行环境和公平性的行为及进行其他的有损于博雅或其他用户合法权益的行为。博雅也绝对不会允许您从事这些行为，亦有权采取技术措施防止您从事这些行为，包括但不限于：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（1）删除或修改博雅游戏上的版权信息，或者伪造ICP/IP地址或者数据包的名称；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（2）进行编译、反编译、反向工程或者以其他方式破解博雅游戏的行为；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（3）进行任何破坏博雅游戏公平性或者其他影响游戏正常秩序的行为，如主动使用外挂或被动刷分、合伙作弊、使用游戏外挂或者其他的作弊软件、利用BUG（又叫“漏洞”或者“缺陷”）来获得不正当的非法利益，或者利用互联网或其他方式将游戏外挂、作弊软件、BUG公之于众；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（4）利用劫持功能变数名称服务器等技术非法侵入、破坏博雅游戏之服务器软件系统，或者修改、增加、删除、窃取、截留、替换博雅游戏之客户端和/或服务器软件系统中的数据，或者非法挤占博雅游戏之服务器空间，或者实施其他的使之超负荷运行的行为；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（5）进行任何诸如发布广告、销售商品的商业行为，或者进行任何非法的侵害博雅利益的行为，如贩卖游戏币、游戏道具、外挂或倒币、刷币等；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（6）发表、转发、传播含有谩骂、诅咒、诋毁、攻击、诽谤、骚扰博雅和/或第三方内容的，或者含有封建迷信、淫秽、色情、下流、恐怖、暴力、凶杀、赌博、反动、扇动民族仇恨、危害祖国统一、颠覆国家政权等让人反感、厌恶的内容的非法言论，或者设置含有上述内容的网名、游戏角色名；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（7）在博雅游戏当中进行恶意刷屏、恶意耗时等恶意破坏游戏公共秩序的行为；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（8）利用博雅游戏故意传播恶意程序或电脑病毒，或者利用博雅游戏发表、转发、传播侵犯第三方知识产权、肖像权、姓名权、名誉权、隐私或其他合法权益的文字、图片、照片、程序、视频、图象和/或动画等资料，发布假冒博雅游戏官方网站网址或链接。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.5</span><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">用户在此完全同意并接受，当用户的数据明显异常时，博雅有权通过查找用户IP地址或运用相关技术手段自行判断用户是否存在作弊以及其他违规行为并作出处罚措施</span></strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.6</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">未经博雅允许，您不得进行下列任何一种行为；您如果要进行下列任何一种行为，请您与博雅联系，取得博雅的同意，并应博雅的要求与之签订电子的或者纸版的书面合同：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（1）对博雅游戏进行扫描、探查、测试，以检测、发现、查找其中可能存在的BUG或弱点；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（2）修改、复制、发行、出租、出版、翻译、汇编、改编和/或转载博雅游戏，或其软件要素作品、游戏过程衍生品、游戏编辑衍生品，或者利用互联网或其他的方式将其公之于众；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（3）建立有关博雅游戏，或其软件要素作品、游戏过程衍生品、游戏编辑衍生品的镜像站点，或者进行网页（络）快照，或者利用博雅游戏架设服务器，为他人提供与之完全相同或者类似的互联网服务；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（4）在博雅游戏当中内置各种插件程序或者其他的第三方程式；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（5）将软件要素作品从博雅游戏中分离出来单独使用，或者进行其他的不符合本协议合同目的的使用；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（6）生产、制作、批发、销售、出版和/或发行游戏改编衍生品；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（7）使用博雅游戏的名称、商标和/或其软件要素作品；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（8）实施上列行为之外的需要博雅同意的其他的有关博雅游戏的行为。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.7 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">如果您当前使用的帐号并不是您申请或者通过博雅提供的其他途径取得的，但您却知悉了该帐号当前的密码，则请您在第一时间内通知博雅或者该帐号的申请人。而且，您不得：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（1）使用该帐号及密码登录博雅游戏、博雅博雅客服官方网站、博雅邮箱和/或享受博雅提供的其他的互联网服务；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（2）修改该帐号项下的密码、申请资料、个人资料、邮件；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（3）利用该帐号买卖、转让、赠与、接受赠与游戏币、游戏道具等虚拟货币或物品； </span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（4）以转让、贩卖、赠与的方式将该帐号或其项下的密码、个人资料、游戏币、游戏道具等资料提供给博雅和申请人之外的无关的第三方，或者对该帐号或其项下的上述资料进行其他形式的处分；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（5）通过互联网或者其他的方式将该帐号及其项下的密码、个人资料、游戏币、游戏道具等虚拟货币或物品公之于众； </span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（6）以其他的方式使用或处分该帐号、密码以及该帐号项下的资料。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.8 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅可能在博雅游戏官方网站或第三方合作平台为用户提供了博雅客户端软件的下载服务，请您到该网站或第三方合作平台上下载该客户端软件及其升级版本。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.9 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅可能通过博雅游戏官方网站或其他方式，为您提供了诸如“游戏商城”等获得游戏币、游戏道具等虚拟物品的途径，您可以从博雅提供的这些途径获得上述虚拟物品。博雅禁止通过接受赠与或者其他的方式从非博雅及博雅合作方的第三方获得上述游戏物品，因为上述途径获得的虚拟物品可能是盗号分子盗窃得来的赃物或者存在其他的权利瑕疵，受害者可能会通过各种手段要求索回。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.10</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅可能通过博雅游戏官方网站、博雅客服官方网站、客服电话、游戏管理员或者其他的途径，向您提供诸如游戏规则说明、游戏BUG或外挂投诉、游戏物品找回、游戏物品锁定或解除锁定、帐号申诉、帐号暂时封停、博雅游戏帐号实名注册信息修改和/或查验等客户服务，您应当：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（1）通过博雅客服官方网站、博雅客服电话或者博雅提供的其他途径了解这些客户服务的内容、要求以及资费，谨慎选择是否需要享受相应的客户服务，向博雅真实地准确地表达您的需求；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（2）不得在接受博雅提供的服务的过程中进行本协议第8.4条所述的第（6）项行为；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（3）同意并接受博雅关于该等客户服务的专门协议或条款；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（4）按照博雅的要求如实提供您的包括有效身份信息在内的个人信息和游戏情况，及您掌握的其他用户或博雅游戏本身的情况，例如：您的博雅帐户及其项下的个人资料、博雅游戏的登录情况和游戏物品情况，博雅游戏当中存在的BUG、外挂及您知晓的其他玩家使用BUG或外挂的情况。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.11 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅在向您提供本协议第8.10条所述的客户服务的过程中，有利要求您通过线上填写投诉单，发送电子邮件、截屏、录影，邮寄纸质书信，提供本人有效身份证件或者其他的方式，向博雅书面说明您的需求、提供有关情况及证据，您应当如实地、最大限度地、毫无保留地提供。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.12</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您在享受本协议第8.10条所述的客户服务的过程中，博雅可能需要通过互联网对您使用的电脑进行远程协助。您如果请求博雅提供该等客户服务，则需要您授予博雅进行远程协助的许可权，并自行承担由此可能给您造成的损失。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.13 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅将会尽最大的努力提高本协议第8.10条所述的客户服务的品质、满足您的服务要求。即便是如此，博雅仍保留向您收取相应的服务费或者其他报酬的权利，而且不保证其提供的服务就一定能够满足您的要求。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.14</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅游戏可能根据博雅游戏的内容在网络游戏的显著位置，向您介绍博雅游戏的游戏规则。您完全同意并承诺按照这种游戏规则进行相应的游戏的；您如果不同意，请您不要下载、安装、启动、登录、显示、运行博雅游戏，您下载、安装、启动、登录、显示和/或运行的行为，即视为您同意并接受这些游戏规则。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.15 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">如果在使用和享受博雅游戏产品及服务的过程中，您发现博雅游戏完全或者部分不能实现博雅所介绍的对应的游戏规则的，请您立即停止使用不符合游戏规则的这一部分游戏内容或者游戏区域，并在第一时间内通知博雅，博雅将会尽快进行修复，使之符合这些游戏规则。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.16 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅如果尚未将博雅游戏的某一款或某几款博雅游戏注册商标的，您不得擅自将其注册商标。否则，您应当配合博雅申请商标局撤销该注册商标，或者将您取得注册商标无偿地、完全地、不可撤销地转让给博雅。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.17</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：博雅可能会不定期地通过发布软件升级包或软件补丁、线上升级等方式对博雅游戏进行更新。更新的过程中，博雅可能通过互联网调取、收集您的个人电脑上的关于博雅游戏的客户端软件版本信息、数据及其他有关资料，并自动进行替换、修改、删除和/或补充。此种行为是软件更新的所必须的一种操作或步骤，您如果不同意博雅进行此种操作，请您不要进行更新；您更新的行为即视为您同意博雅进行此种操作。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.18</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：对于博雅游戏来说，本协议第8.17条所述的某些更新可能是软件版本的更新，如果您不进行此种更新则将无法登录博雅游戏。而且，此种更新将会导致您使用的电脑上原有的软件版本完全被新的软件版本替换掉。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.19</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：游戏数据将会占据博雅游戏的服务器空间。长时间保留您在使用和享受博雅游戏产品及服务的过程中所产生的全部游戏数据，将会大量地挤占服务器空间，影响您及其他博雅游戏用户的游戏速度，增加博雅的运营成本，是完全没有必要的。因此，博雅将会定期将服务器上存储的一些过往的游戏数据转移或者永久地删除。对此，您是完全同意的。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.20 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">为了测试博雅游戏的功能、用户承载能力、查找其中可能存在的BUG或者进行其他的检测其品质的行为，博雅可能会在博雅游戏对外正式发布（又称“公测”）之前或之后发布一些供用户体验、测试并回馈意见的软件测试版本（一般都是正式运营版本以及不删档内测版本和公测版本之外的其他的软件测试版本，包括但不限于封测版本、内测版本和外部测试版本），并通过向您提供启动码、该版本客户端软件下载的网路链接地址、发送客户端软件等形式邀请您参加体验、测试。而且，博雅可能会向用户同时提供两种或两种以上版本的博雅游戏产品，而其中的某些版本仅限于由某一部分用户登录使用，其他的用户则不能登录使用。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.21 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：本协议第8.20条所述的软件测试版本，并不是向所有的用户公开的，请您不要把您知晓的启动码、客户端软件下载的网路链接地址告诉他人，也不要将客户端软件提供给他人。而且，您应当按照博雅的要求如实地、毫无保留地、准确地、完全地将您在体验、测试过程中发现的诸如存在BUG情况告诉博雅。而且，未经博雅同意，您不得将该等情况提供给第三方，或者通过互联网或其他方式将其公之于众。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.22</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：本协议第8.20条所述的软件测试版本，只是博雅用来供部分用户体验、测试的临时的版本，博雅将会在认为其已经完成使命的时候将该版本之服务器软件从服务器上删除，或者用新的软件版本将其替换掉。一经删除或者替换：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（1）您将不能继续登录、使用该版本；且</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（2）您在体验、测试过程中产生的游戏数据将会被永久性删除； </span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（3）您在体验、测试过程中取得的游戏币、游戏道具、积分、等级或者荣誉等将会被永久性删除，您将永远不能在博雅游戏使用这些资料，即便是您使用同一个游戏帐号登录、使用该软件的其他的版本，亦是如此。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.23 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：您在使用和享受博雅游戏产品及服务（包括但不限于享受本协议上述第8.10条所述的客户服务）的过程中，博雅可能会借助cookie收集您使用博雅游戏的情况。对此，您是充分理解并完全同意的。您如果不同意，可以通过设置您使用的电脑上的Internet选项来进行规避。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.24</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您承诺并保证：您对您通过本协议所述的方式提供给博雅的作品享有完全的著作权，或者虽然不享有著作权，但享有将其许可给博雅用于博雅游戏之中的权利。而且，该等使用既可能是将其用于博雅游戏开发之中，也可能是将其用于博雅游戏的市场推广活动（如广告）之中。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.25</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅可能会在使用您提供的作品之前，要求您出具书面的授权证明及您的身份证明（如身份证复印件）。如果博雅在使用您提供的作品的同时，需要一并使用您的肖像、姓名或者其他合法权益的，您同意将您的肖像、姓名和/或其他合法权益一并授权给博雅使用。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">8.26</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解并同意，在使用博雅服务过程中应当遵守当地相关的法律法规，并尊重当地的道德和风俗习惯。<strong>如果您的行为违反了当地法律法规或道德风俗，您应当为此独立承担责任。</strong></span>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">9.</span></strong><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">用户违规处罚规则</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">9.1 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您如有违反本协议第8条约定的用户行为守则，博雅有权采取本协议第9.2条所述措施中的一种或几种行为，如您的行为给博雅造成经济损失的或者有损博雅商业信誉、企业形象的，博雅可以要求您给予赔偿并公开赔礼道歉；构成国务院《著作权行政处罚实施办法》或者其他法律法规所规定的违法行为的，博雅将提请国家版权局等有关行政管理机关对您进行行政处罚；构成犯罪的，博雅将向有关的司法机关举报，追究您的刑事责任。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">9.2 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅有权根据用户的违规行为采取下列措施当中的一种或几种：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（1）暂时禁言，即暂时禁止您凭藉当前使用的游戏帐号在博雅游戏当中发表任何言论，使之在禁言期限不能发表任何言论；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（2）暂时或永久封号，即暂时或永久封停您的游戏帐号，使之在封停期限内不能登录博雅游戏；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（3）删除广告、虚假信息和/或非法言论，即永久性地、不可撤销地将您发布的广告、虚假信息或者非法言论删除，或者采取其他的阻止其传播的措施；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（4）删除赃物，即永久性地、不可撤销地将您非法获取的游戏币、游戏道具等游戏物品删除，或者将其返还给原来的通过合法途径取得其使用权的其他用户；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（5）扣除或清零游戏币，即永久性地、不可撤销地将您非法获取或违反本协议规定取得或通过非博雅授权渠道取得的游戏币、积分、等级和/或荣誉扣除或清零；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（6）拒绝受理帐号申诉；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（7）其他措施，即采取上列措施之外的其他措施。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">该违规罚则不限定语言，不论符合该项违规罚则的名称是中文或是其它语言，都将遵照处罚措施进行处罚。上述游戏违规罚则内容，非永久内容，博雅有权依据国家法规以及环境不同进行内容上的修改、变更，并将变更后的违规罚则公布于官方网站。如您因对变更后的游戏违规罚则不熟悉而引起的损失，博雅一律不予以赔偿。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">9.3</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">针对您实施的本协议第9.1条所述的行为，博雅可能会连续地、间断地或者交替地采取本协议第9.2条所述的措施当中的一种或几种，并视情节轻重永久或暂时中止您之全部或部份网络服务使用权，由此造成的账号内虚拟货币、积分、虚拟道具等电子记录之损失应由您自行承担。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">9.4 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅可能会通过在博雅登录窗口及其官方网站或者其他的途径公布该游戏存在的BUG。即便是如此，亦不能免除在博雅公布之前您负有的本协议第8.4条所述的第（3）项义务。换言之，即便是没有对外公布BUG，博雅也可以自行判断您是否使用了BUG。而且，博雅一经判断您使用了BUG，即可对您当前使用的游戏帐号采取本协议第9.2条所述的措施。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">9.5 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您提请博雅提供本协议第8.10条所述的客户服务时，如不按照第8.11条之约定提供相应的资料及证据的，博雅有权拒绝提供相应的客户服务。</span>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">10.</span></strong><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">用户纠纷处理机制</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">10.1</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">用户就游戏账号的使用权归属或游戏数据等存在争议，可以通过博雅或博雅游戏官方网站“在线提问”或博雅提供的其他方式请求博雅公司客户服务人员处理。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">10.2</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0"> 用户承诺遵守博雅处理此类事务的要求、流程，对自己的主张提供相应的材料予以证明。如用户不能提供充分材料证明其主张成立，因此致使其受到损害，则由用户独立承担全部责任。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">10.3</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0"> 用户同意以博雅服务器或系统所记载的数据作为处理用户之间或用户与博雅之间纠纷的判断标准。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">10.4</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0"> 用户自行承担其因处理此类纠纷而产生之通讯费、邮寄费、交通费等一切费用。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">10.5</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0"> 用户如对博雅做出的纠纷处理存在争议，可以在博雅作出处罚之日起10天内通过博雅或博雅游戏官方网站“在线提问”或博雅提供的其他方式提出申诉申请，请求博雅客户服务人员处理，说明您的异议理由，并根据博雅的要求提供相关资料。但这不会导致该等处罚措施无效，也不影响异议期间该等处罚措施的执行。如因用户未在10天内对处罚措施提出异议或是虽提出异议但无法在10天内提供充足的证明资料的，则视为您没有任何异议，博雅不再接受任何有关的反馈。</span>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">11.&nbsp;</span></strong><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">通知和送达</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">11.1</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅对违规用户处以本协议第9.2条所述的处罚措施时不负处罚前通知的义务。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">11.2</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅会通过博雅网站、博雅论坛、游戏通告栏以及游戏系统信息等发布公告为主要通知方式，自公告发布之日起即为送达。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">11.3</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅在个别情况下有可能会通过登录提示、电子邮件、常规信件或电话等方式通知，但博雅没有以此方式进行个别通知的义务。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">11.4</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">用户承诺谨慎注意博雅的通知，因用户自身原因没有及时看到通知而产生的损害，博雅对此不承担任何责任。</span>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.</span></strong><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">服务风险和免责条款</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.1 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">如果您不具备本协议第8.1所述的条件，您将不能使用博雅游戏或博雅游戏的部分功能。博雅对此无须向您承担任何责任。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.2</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅游戏与其他的线上使用的互联网软件一样，也会受到各种不良信息、网路安全和网路故障问题的困扰，包括但不限于：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（1）其他用户可能会发布诈骗或虚假信息，或者发表含有谩骂、诅咒、诋毁、攻击内容的，或含有淫秽、色情、下流、反动、煽动民族仇恨等让人反感、厌恶的内容的非法言论；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（2）其他用户可能会发布一些侵犯您或者其他第三方知识产权、肖像权、姓名权、名誉权、隐私和/或其他合法权益的图片、照片、文字等资料；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">（3）面临着诸如骇客攻击、电脑病毒困扰、系统崩溃、网路掉线、网速缓慢、程序漏洞等问题的困扰和威胁。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.3 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：上述第12.2条所述的各种不良信息、网路安全和网路故障问题，并不是博雅或博雅游戏所导致的问题，由此可能会造成您感到反感、恶心、呕吐等精神损害，或者给您造成其他的损失，一概由您自行承担，博雅和/或博雅游戏无须向您承担任何责任。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.4 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：博雅未授权您从任何第三方通过购买、接受赠与或者其他的方式获得游戏账号、游戏币、游戏装备及其他游戏道具、游戏服务等，博雅不对第三方交易行为（第三方交易，是指您从第三方通过购买、接受赠与或者其他的方式获得游戏账号、游戏道具、游戏装备、游戏币及其他游戏服务的行为）负责，并且不受理因任何第三方交易发生纠纷而带来的申诉。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.5</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：博雅通过本协议所述的方式向您介绍的游戏规则可能是不充分的、有限的。博雅不保证对博雅游戏规则的介绍是完全的、充分的、没有任何错漏的，也不保证博雅游戏能够完全地、充分地、没有任何错漏地实现这些游戏规则。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.6 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：博雅为了有效遏制博雅游戏中用户使用BUG或外挂的行为，可能会采取停机维护或者回档的处理措施。停机维护期间，您可能会不能登录博雅。回档，则是将所有用户游戏帐号项下的游戏数据从某一个时刻的记录返回到此前的另一个时刻的记录，由此可能会导致您在这期间通过正常游戏行为获得的游戏币、游戏道具等游戏物品和等级、积分、荣誉等永久性丧失，或者给您造成其他的损失。对此，您充分理解并愿意自行承担，博雅将不给予任何赔偿。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.7 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：博雅可能会将合作单位提供的某些服务（如合作单位提供的某些软件的有期限限制的使用权或旅游服务）或者实物作为奖品赠送给您，博雅将会按照您提供的联系方式与您联系，并将这些服务或实物提供给您。但博雅对该等服务和/或服务的品质不作任何明示或者默示的担保，如该等服务和/或实物存在品质问题，请直接与相应的合作单位联系，并自行与之解决相关的争议或纠纷，一概与博雅无关。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.8 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您充分理解到：博雅游戏可能会因博雅本身或者合作单位的互联网系统软硬件设备的故障、失灵、或人为操作的疏失而全部或一部分中断、暂时无法使用、迟延，或因他人侵入博雅游戏系统篡改或伪造变造资料等，造成博雅游戏的停止或中断者或用户档案缺失，您不得要求博雅给予您任何的补偿或赔偿。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.9 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您同意您使用和享受博雅游戏产品及服务是出于您个人意愿，并愿自行承担任何风险及由此给您造成的任何直接、间接、衍生的损害，博雅不承担任何责任。若依法无法完全排除损害赔偿责任时，博雅的赔偿责任亦以返还用户因此支付博雅的价款为限。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.10 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅保留随时地、不事先通知地、不需要任何理由地、单方面地中止履行本协议及终止本协议的权利。该等中止、终止，可能是因为博雅解散、注销、合并、分立，也可能是因为博雅将博雅游戏的著作权，或其运营权转让给了第三方，还可能是因为国家法律、法规、政策及国家机关的命令或者其他的诸如地震、火灾、海啸、台风、罢工、战争等不可抗力事件，还可能是上列原因之外的其他原因。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.11 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">本协议如因第12.10条所述原因：</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">(1)&nbsp;</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">被中止，则包括您在内的所有用户将暂时不能凭借游戏账号登录博雅，直至本协议中止期限届满之日止；</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">(2)&nbsp;</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">被终止，则包括您在内的所有用户将永远不能凭借游戏账号登录博雅，博雅将以公告或者以其他的形式处理相关事宜。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">12.12 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">您知悉并同意，在任何情况下，博雅不对因不可抗力导致的您在使用博雅游戏服务过程中遭受的损失承担责任。</span>
</p>
<p>
    <strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">13.</span></strong><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">其他约定</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">13.1 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅有权在必要时修订、变更本协议条款，您可在网络游戏相关页面查阅最新版本的协议条款，本协议条款变更后，如您继续使用博雅游戏服务，即视同您同意并完全接受变更后的协议。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">13.2</span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">本协议条款无论因何种原因部分无效，其余条款仍有效，对各方具有约束力。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">13.3 </span><span style="font-size:11px;font-family:FZLTHK--GBK1-0">本协议各条款的标题只是为了方便用户阅读而起到提示、醒目的作用，对本协议的解释及适用没有任何指引作用。</span>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">13.4</span><strong><span style="font-size:11px;font-family: FZLTHK--GBK1-0">本协议签订地为广东省深圳市南山区，受中华人民共和国法律、法规管辖，博雅保留最终解释权。</span></strong>
</p>
<p>
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">13.5</span><strong><span style="font-size:11px;font-family:FZLTHK--GBK1-0">若您和博雅之间因本协议发生任何纠纷或争议，首先应友好协商解决；协商不成的，您同意将纠纷或争议提交至本协议签订地有管辖权的人民法院管辖。</span></strong>
</p>
<p style="text-indent:28px">
    <span style="font-size:11px;font-family:FZLTHK--GBK1-0">博雅互动集团严格遵守国家法律法规以及相关政府规定，依法合规经营游戏产品，力求为棋牌游戏爱好者打造一个健康、绿色的游戏休闲氛围。同时，博雅专门设立客服举报监督专线：400-688-7026，欢迎广大用户玩家对游戏中的违法行为进行举报！</span>
</p>
</div>
  </div>
</template>

<script>

export default {
    beforeCreate(){
        document.querySelector('body').setAttribute('style','background: none');
    },
    //页面销毁之前执行
    beforeDestroy(){
        document.querySelector('body').removeAttribute('style');
    },
}
</script>

<style scoped lang="scss">
.server-con{
  color:#A06D4E;
  font-size:.6875rem;
  font-family: "FZLTHK--GBK1-0";
    .content{
        color:#A06D4E;
        font-size:.6875rem;
        font-family: "FZLTHK--GBK1-0";
        .title_text{
            text-align: center;
            font-family:FZLTHK--GBK1-0;
            font-weight:900;
            margin:30px 0;
            font-size:22px 
        }
    }
}
</style>